<template>
    <div class="vfb-field vfb-field--control" :class="classes.wrapper">
        <div class="vfb-field__container" :class="[classes.container, { 'has-value': hasValue }]">
            <FormLabel :id="id" :label="label" :required="required"
                       :className="classes.label"></FormLabel>

            <input class="vfb-input"
                   :class="[classes.input, { 'has-value': hasValue }]"
                   @input="(event) => handleInput(event)"
                   :disabled="disabled" :required="required"
                   :placeholder="placeholder"
                   :value="modelValue"
                   :type="type"
                   :name="name"
                   :id="id"
                   :autocomplete="autocomplete"
                   :aria-describedby="helpText ? id + '-help-block' : undefined"
            >

            <HelpText v-if="helpText" :helpText="helpText" :id="id + '-help-block'" :className="classes.help"/>
        </div>

        <FormErrors class="vfb-errors" :class="classes.errors"/>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import FormLabel from './Label.ce.vue'
import FormErrors from './Errors.ce.vue';
import HelpText from './includes/HelpText.ce.vue';

interface Classes {
    wrapper?: string;
    container?: string;
    input?: string;
    label?: string;
    help?: string;
    errors?: string;
}

interface Props {
    required?: boolean,
    disabled?: boolean,
    label: string,
    name: string,
    modelValue?: string,
    type?: string,
    placeholder?: string,
    helpText?: string,
    id: string,
    classes?: Classes,
    autocomplete?: string,
    isHtmlLabel?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
    type: 'text',
    size: 'default',
    disabled: false,
    required: false,
    placeholder: '',
    modelValue: '',
    name: '',
    helpText: '',
    label: '',
    autocomplete: 'off',
    classes: () => ({
        wrapper: 'js-form-validation__group',
        container: 'form-group',
        input: 'form-control',
        label: 'form-label',
        help: '',
        errors: '',
    })
})

const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void
}>()

const hasValue = computed<boolean>(() =>
	(props.modelValue !== null && props.modelValue !== undefined && props.modelValue.length > 0) ||
	(props.placeholder !== null && props.placeholder !== undefined && props.placeholder.length > 0)
)

const handleInput = (event: Event) => {
	emit('update:modelValue', (event.target as HTMLInputElement).value);
}




</script>
